module.exports = __webpack_public_path__ + "static/img/ad-5.dc5b19f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-5.png
// module id = 6OO5
// module chunks = 0